import { IFieldsMapContainerContext } from "../fields/map"
import { IMapTopologyService } from "../map/topo/types"
import { IDataLayer, IDatalayerContext, IDatalayerFactory, IDatalayerMapDependencies, IDatalayerMapInstance, IDatalayersLoader, IDatalayerViewManager, SharedLayersService } from "./types"

export class MapDependencies implements IDatalayerMapDependencies {

    public readonly $rootScope = this.base.$rootScope
    public readonly $compile = this.base.$compile
    public readonly $timeout = this.base.$timeout

    public readonly shell = this.base.shell

    public readonly bingKey = this.base.bingKey
    public readonly customBasemaps = this.base.customBasemaps
    public readonly measuringService = this.base.measuringService

    public readonly fieldSvc = this.base.fieldSvc
    public readonly loader: IDatalayersLoader = this.svc

    static $inject = [
        "OmniaFieldsMapContext",
        "OmniaDatalayersService",
        "OmniaDatalayersFactory",
        "OmniaDatalayersViewManager",
        "OmniaMapTopologyService",
    ]

    constructor(
        private base: IFieldsMapContainerContext,
        public readonly svc: SharedLayersService,
        public readonly factory: IDatalayerFactory,
        public readonly viewManager: IDatalayerViewManager,
        public readonly topology: IMapTopologyService
    ) {

    }

    private createMapLayerInstance(ctxt: IDatalayerContext, layer: IDataLayer) {
        return this.factory.create(layer, ctxt)
    }

    ensureLoaded() {
        return this.svc.refresh()
    }

    createContext(getAllLayers: () => IDatalayerMapInstance[]): IDatalayerContext {

        const caches = {}

        const ctxt: IDatalayerContext = {

            createMapLayerInstance: l => this.createMapLayerInstance(ctxt, l),

            loader: this.loader,
            viewManager: this.viewManager,
            measuringService: this.measuringService,
            sharedData: this.svc.sharedData,

            getCache(id: string) {
                const cache = caches[id] || (caches[id] = {})
                return cache
            },

            getAllLayers,

            getAllFields: () => this.base.fieldSvc.fields

        }

        return ctxt

    }

    queryLocationApi(query: string) {
        return this.base.queryLocationApi(query)
    }

}
